import shippingBase from '../schemas/shippingBase';
import {vatId} from '../field-templates/vat-id/vatId';
import {buildField} from '../field-templates/fieldBuilder';

export default function checkoutShipping(isReferralIdCustomer){
    const checkoutShippingFormGroups = [
        {
            styleClasses: "row",
            fields: [buildField(vatId)],
        },
    ]

    return {
        groups: shippingBase(isReferralIdCustomer).groups.concat(checkoutShippingFormGroups)
    }
}
